import React from "react";
import { Button } from "@mui/material";
import { AllowedValuesDTO, SiteByIdDTO } from "api";

import { AddCollectorButton } from "./add-collector-button";

const buttonStyle: React.CSSProperties = {
  fontSize: "12px",
  width: "85px",
  height: "20px",
  padding: "0",
  minWidth: "80px",
  minHeight: "20px",
};

interface LabelWithButtonProps {
  label: React.ReactNode;
  onClickOtherSites: () => void;
  siteId: number | undefined;
  isEmpty: boolean;
  allowedValues: AllowedValuesDTO;
  siteData: SiteByIdDTO;
  setNewSite: React.Dispatch<React.SetStateAction<{ id: number | undefined, name: string }>>;
  setNewCollectorId: React.Dispatch<React.SetStateAction<number | undefined>>;
}

export const RenderLabelWithButton = ({
  label,
  onClickOtherSites,
  siteId,
  isEmpty,
  allowedValues,
  siteData,
  setNewSite,
  setNewCollectorId,
}: LabelWithButtonProps) => (
  <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
    <span>{label}</span>
    <Button
      sx={buttonStyle}
      variant="contained"
      color="primary"
      onClick={onClickOtherSites}
    >
      {siteId === 0 || siteId === -1 || siteId === undefined ? "Other Sites" : "Change"}
    </Button>
    {isEmpty && <AddCollectorButton
      buttonsStyle={buttonStyle}
      allowedValues={allowedValues || ({} as AllowedValuesDTO)}
      currentBillData={siteData}
      setNewSite={setNewSite}
      setNewCollectorId={setNewCollectorId}
    />}
  </div>
);

